'use strict';

var helper = require('../helper');

module.exports = {
    // 6.108 REFUND OPTION - MOTIVATION SELECT
    pushRefundOptionMotivationSelect (motivation, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '113',
            'eventname': 'return',
            'step': 'motivation_select',
            'text': motivation,
            'product_id': sku
        };
        helper.log('Pushing refund option - motivation select interaction!', true);
        helper.push(pushObject);
    },

    // 6.109 REFUND OPTION - SHIPPING METHOD
    pushRefundOptionShippingMethod (shippingMethod, skus) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '40',
            'eventname': 'return',
            'step': 'shipping_select',
            'shipping_method': shippingMethod,
            'product_id': skus
        };
        helper.log('Pushing refund option - shipping method select interaction!', true);
        helper.push(pushObject);
    },

    // 6.110 REFUND OPTION - PAYMENT METHOD
    pushRefundOptionPaymentMethod (paymentMethod, skus) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '114',
            'eventname': 'return',
            'step': 'payment_select',
            'payment_method': paymentMethod,
            'product_id': skus
        };
        helper.log('Pushing refund option - payment method select interaction!', true);
        helper.push(pushObject);
    },

    // 6.111 REFUND OPTION - CONFIRMATION
    pushRefundOptionConfirmation (skus, shippingMethod, paymentMethod, transactionID) {
        if (!skus || !shippingMethod || !paymentMethod) {
            return;
        }
        if (!transactionID) {
            transactionID = 'transaction_id_not_available';
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '115',
            'eventname': 'return_confirmation',
            'step': 'confirmation',
            'order': transactionID,
            'product_id': skus,
            'shipping_method': shippingMethod,
            'payment_method': paymentMethod
        };
        helper.log('Pushing refund option confirmation interaction!', true);
        helper.push(pushObject);
    }
};
